import ResultsTab from './ResultsTab';

export default ResultsTab;
